<block-ui>
    <div class="d-flex flex-row-reverse">
        <div class="form-group mb-0">
            <button type="button" class="form-control form-control-sm btn-light shadow-sm float-right"
                (click)="RaisePermissionModal(content_permission)">
                <i aria-hidden="true" class="fa fa-plus cursor-hand"></i>
                Agregar permiso
            </button>
        </div>
    </div>
    <div class="tableFixHead mt-2">
        <table class="table table-striped table-sm mt-2">
            <thead style="background-color: #172749; color: white;">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Nombre</th>
                    <th scope="col">Codigo</th>
                    <th scope="col">Tipo</th>
                    <th class="text-center" scope="col">Activo</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let permission of permissions; let i = index" class="p-0">
                    <td scope="row">{{(i + 1)}}</td>
                    <td>{{permission.Name}}</td>
                    <td>{{permission.Code}}</td>
                    <td>{{GetPermissionType(permission.Type)}}</td>
                    <td class="text-center"><i class="fa fa-{{permission.IsActive ? 'check': 'times'}}"></i>
                    </td>
                    <td class="justify-content-center option clasesita">
                        <i class="fa fa-edit" style="cursor: pointer;" title="Editar permiso" (click)="GetPermission(permission.Id, content_permission)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</block-ui>
<ng-template #content_permission let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Permiso</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="permissionForm">
            <div class="form-group" style="display: none;">
                <label for="">Id</label>
                <input type="number" class="form-control form-control-sm" aria-describedby="" formControlName="Id">
            </div>
            <div class="form-group mRequired">
                <label for="">Nombre</label>
                <input type="text" class="form-control form-control-sm" aria-describedby="" formControlName="Name">
            </div>
            <div class="form-group mRequired">
                <label for="">Codigo</label>
                <input *ngIf="permissionForm.get('Id').value == -1" type="text" class="form-control form-control-sm"
                    aria-describedby="" formControlName="Code">
                <input *ngIf="permissionForm.get('Id').value != -1" readonly type="text"
                    class="form-control form-control-sm" aria-describedby="" formControlName="Code">
            </div>
            <div class="form-group mRequired">
                <label for="">Tipo</label>
                <select class="form-control form-control-sm" formControlName="Type">
                    <option value="0">Lectura</option>
                    <option value="1">Modificación</option>
                </select>
            </div>
            <div class="form-check">
                <input type="checkbox" class="form-check-input" formControlName="IsActive"
                    style="transform: scale(1.5);">
                <label class="form-check-label" for="exampleCheck1">Activo</label>
            </div>
        </form>
        <br>
        <div class="row">
            <div class="col-sm-4 offset-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="StorePermission()">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    Guardar
                </button>
            </div>
            <div class="col-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="ClosePermissionModal()">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                    Cerrar&nbsp;
                </button>
            </div>
        </div>
    </div>
</ng-template>